import React from 'react';

const SvgAn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="AN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="AN_svg__b" fill="#fff">
        <use xlinkHref="#AN_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#D6182D"
        mask="url(#AN_svg__b)"
        d="M10.667 0h6.667v20h-6.667z"
      />
      <path fill="#1425A2" mask="url(#AN_svg__b)" d="M0 6.667h28v6.667H0z" />
      <path
        fill="#FFF"
        mask="url(#AN_svg__b)"
        d="M11.333 11.667l-.471.138.138-.472-.138-.471.471.138.472-.138-.138.471.138.472zM16.667 11.667l-.472.138.138-.472-.138-.471.472.138.471-.138-.138.471.138.472zM8.667 10.333l-.472.138.138-.471-.138-.471.472.138.471-.138L9 10l.138.471zM19.333 10.333l-.471.138L19 10l-.138-.471.471.138.472-.138-.138.471.138.471zM14 9l-.471.138.138-.471-.138-.472.471.138.471-.138-.138.472.138.471z"
      />
    </g>
  </svg>
);

export default SvgAn;
